export const MatchupCardSkeleton = ({ areCurrentMatchupsShown }: { areCurrentMatchupsShown: boolean }) => (
	<div
		className={`rounded-xl border px-4 py-3 relative ${areCurrentMatchupsShown ? 'bg-darkorange-25 border-darkorange-300' : 'bg-white border-gray-200'} animate-pulse`}
	>
		<div className="absolute top-3 right-3">
			<div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-sm font-medium border bg-white border-gray-200 text-gray-700">
				<div className={`w-2 h-2 rounded-full ${areCurrentMatchupsShown ? 'bg-orange-700' : 'bg-orange-500'}`} />
				<span className="text-xs inline">{areCurrentMatchupsShown ? 'Live score' : 'Coming up!'}</span>
			</div>
		</div>
		<div className="mb-3 pr-24">
			<div className="h-4 bg-gray-200 rounded w-2/3 mb-1" />
			<div className="h-4 bg-gray-200 rounded w-1/2" />
		</div>
		<div className="space-y-1.5 mb-3">
			<div className="flex items-center justify-between">
				<div className="h-5 bg-gray-300 rounded w-3/4" />
				<div className="h-6 bg-gray-300 rounded w-1/5" />
			</div>
			<div className="flex items-center justify-between">
				<div className="h-5 bg-gray-300 rounded w-3/4" />
				<div className="h-6 bg-gray-300 rounded w-1/5" />
			</div>
		</div>
		<div className="flex items-center gap-1 text-gray-500 text-sm">
			<div className="h-4 bg-gray-200 rounded w-24" />
		</div>
	</div>
);

export const MatchupCardContainerSkeleton = () => (
	<div>
		<div className="mt-6">
			<p className="text-lg font-bold leading-7 text-gray-900 mb-4 animate-pulse h-6 bg-gray-200 rounded w-48" />
			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-6">
				<MatchupCardSkeleton areCurrentMatchupsShown />
				<MatchupCardSkeleton areCurrentMatchupsShown />
				<MatchupCardSkeleton areCurrentMatchupsShown />
			</div>
		</div>
		<div className="mt-5">
			<p className="text-lg font-bold leading-7 text-gray-900 mb-4 animate-pulse h-6 bg-gray-200 rounded w-48" />
			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
				<MatchupCardSkeleton areCurrentMatchupsShown={false} />
				<MatchupCardSkeleton areCurrentMatchupsShown={false} />
			</div>
		</div>
	</div>
);
